
export const TECH_LOGS = [
    "DÉCODAGE DE L'EMPREINTE HARMONIQUE...",
    "EXTRACTION DES TRANSIENTS NEURAUX...",
    "CORRÉLATION SPECTRALE MASTER VS PRISE...",
    "ALIGNEMENT ATOMIQUE DES ONSETS...",
    "CALCUL DE LA TENSION DIGITALE...",
    "ANALYSE DE LA RÉSONANCE SYMPATHIQUE...",
    "VÉRIFICATION DU FLUX RYTHMIQUE...",
    "MAPPING DES HARMONIQUES CACHÉES...",
    "ÉVALUATION DE LA PRÉCISION DU PICKING...",
    "SYNCHRONISATION DES PHASES AUDIO..."
];

export const SIGNATURE_MESSAGES_FR = [
    "J’écoute la précision de votre placement rythmique.",
    "Je distingue la clarté de chaque note jouée.",
    "Je mesure la régularité de votre pulsation.",
    "J’identifie les nuances dans votre attaque de cordes.",
    "J’évalue la fluidité de vos enchaînements.",
    "J’isole vos points de force technique.",
    "Je prépare votre plan de progression personnalisé."
];

export const SIGNATURE_MESSAGES_EN = [
    "I am listening to your rhythmic placement.",
    "I am discerning the clarity of every note.",
    "I am measuring the consistency of your pulse.",
    "I am identifying the nuances in your attack.",
    "I am evaluating the fluidity of your transitions.",
    "I am isolating your technical strengths.",
    "I am preparing your personalized progression plan."
];
